import React, { FC } from 'react';
import { withOptimizely, WithOptimizelyProps } from 'shared/optimizely';
import useLiveRamp from 'shared/hooks/optimizely/useLiveRamp';
import Head from 'next/head';
import { ScriptInline } from '../ScriptInline';

import defaultHeader from './assets/header.html.txt';
import experimentHeaderControl from './assets/header-CRME-1269-control.html.txt';
import experimentHeaderMyHome from './assets/header-CRME-1269-my_home.html.txt';
import experimentHeaderSaved from './assets/header-CRME-1269-saved.html.txt';
import experimentHeaderMyHomeSaved from './assets/header-CRME-1269-my_home_saved.html.txt';
import experimentHeaderMyHomeSavedLogo from './assets/header-CRME-1269-my_home_saved_logo.html.txt';
import liveRampScript from './assets/liveramp-consent-management-platform.min.js.txt';

const variationMap: Record<string, string> = {
    control: experimentHeaderControl,
    my_home_only: experimentHeaderMyHome,
    saved_only: experimentHeaderSaved,
    my_home_and_saved: experimentHeaderMyHomeSaved,
    my_home_and_saved_with_condensed_logo: experimentHeaderMyHomeSavedLogo
};

const Header: FC<WithOptimizelyProps> = ({ optimizely }) => {
    const _useLiveRamp = useLiveRamp(optimizely);

    const optimizelyVariation = optimizely?.activate(
        'crme_1269_mobile_my_home_nav'
    );

    let header = defaultHeader;

    if (optimizelyVariation && variationMap[optimizelyVariation]) {
        header = variationMap[optimizelyVariation];
    }

    return (
        <>
            {_useLiveRamp && (
                <Head>
                    <ScriptInline
                        script={liveRampScript.replace(
                            '{{{segmentID}}}',
                            process.env.SEGMENT_ID!
                        )}
                    />
                </Head>
            )}
            <div
                data-testid="universal-header"
                dangerouslySetInnerHTML={{
                    __html: header
                }}
            />
        </>
    );
};

export default withOptimizely(Header);
